import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { partDetailsNCFileConfig } from './config';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';

const PartDetailsNCFileStack = createStackNavigator();

const PartDetailsNCFileNavigator = () => {
  return (
    <PartDetailsNCFileStack.Navigator screenOptions={NAVIGATION_CONFIG}>
      {partDetailsNCFileConfig.map(({ Component, name }) => (
        <PartDetailsNCFileStack.Screen key={name} name={name} component={Component} />
      ))}
    </PartDetailsNCFileStack.Navigator>
  );
};

export { PartDetailsNCFileNavigator };
